import {doGET, doPOST, shopRestBackendBaseUrl, type SubmitOrderLine} from 'dummen-shared';

const ORDER_REST_BACKEND_BASE = `${shopRestBackendBaseUrl}/secured/app/orders`;

const getDeadlineNotPassedUrl = (customerId?: string | null) => {
	const searchParams = new URLSearchParams();

	if (customerId) {
		searchParams.append('customerId', customerId);
	}

	const queryString = searchParams.toString();
	return queryString ? `${ORDER_REST_BACKEND_BASE}/deadline-not-passed?${queryString}` : `${ORDER_REST_BACKEND_BASE}/deadline-not-passed`;
};

export const getOrdersWhereDeadlinesHaveNotPassed = async (customerId?: string | null) => {
	const response = await doGET(getDeadlineNotPassedUrl(customerId));
	return await response.json();
};

export const createPurchaseOrder = async (order: unknown) => {
	const response = await doPOST(`${ORDER_REST_BACKEND_BASE}/create`, JSON.stringify(order));
	return await response.json();
};

export const addToExistingPurchaseOrder = async (orderApplicationId: string, submitDate: {
	orderLines: SubmitOrderLine[]
}) => {
	const response = await doPOST(
		`${ORDER_REST_BACKEND_BASE}/${orderApplicationId}/add-to-existing`,
		JSON.stringify(submitDate)
	);

	return await response.json();
};
